import type { ISubscriptionPlan } from '../redux/subscription/types';
import { getCreatorSubscriptionProvider, hasActiveCreatorSubscriptionBenefits } from './creatorSubscriptionApi';

/** Paid creator plan with active billing benefits (payout fee waiver, etc.). */
export function isActiveCreatorThspianSubscription(sub: ISubscriptionPlan | null | undefined): boolean {
    return hasActiveCreatorSubscriptionBenefits(sub);
}

export { getCreatorSubscriptionProvider };

export function formatCreatorSubscriptionDate(iso?: string | null): string {
    if (!iso) return '—';
    try {
        return new Date(iso).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
    } catch {
        return '—';
    }
}

export function formatCreatorSubscriptionPrice(sub: ISubscriptionPlan): string {
    if (sub.formatted_for_display) return sub.formatted_for_display;
    if (sub.converted_amount) return sub.converted_amount;
    const provider = getCreatorSubscriptionProvider(sub);
    const symbol = sub.toSymbol ?? (provider === 'paystack' ? '₦' : '$');
    const amountCents = sub.plan?.amount ?? sub.amount;
    if (amountCents == null || !Number.isFinite(amountCents)) return '—';
    const amount = amountCents / 100;
    return `${symbol}${amount.toLocaleString('en-US', {
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
    })}`;
}

function normaliseInterval(interval?: string): string {
    if (!interval) return '';
    return interval.replace('monthly', 'month').replace('yearly', 'year');
}

export function creatorSubscriptionIntervalLabel(sub: ISubscriptionPlan): string {
    const interval = normaliseInterval(sub.plan?.interval ?? sub.interval);
    if (interval === 'year') return 'YEAR';
    if (interval === 'month') return 'MONTH';
    return interval.toUpperCase() || 'MONTH';
}

export function resolveCreatorSubscriptionStartDate(sub: ISubscriptionPlan): string | null {
    return sub.start_date ?? sub.created_at ?? null;
}
